import React from 'react'
import ProductCard from '../component/card/product'

function Home() {
  return (
    <>
        <div class="shop-hero">
            <div class="shop-hero-box">
                <div class="box-overlay"></div>
                <div class="overlay-layer">
                    <div class="overlay-content">
                        {/* <div class="inner-content">
                            <h3 class="episode-title">The pinky lady flash sale</h3>
                            <div class="episode-meta">
                                <a href="#" class="meta-item is-hoverable">Flash Sale</a>
                                <span class="separator">|</span>
                                <span class="meta-item">32 mins left</span>
                                <span class="separator">|</span>
                                <a class="meta-item is-hoverable">4 products</a>
                            </div>
                        </div> */}
                    </div>
                </div>
                <img src="https://bulkit.cssninja.io/assets/img/demo/store/hero-1.jpg" data-demo-src="https://bulkit.cssninja.io/assets/img/demo/store/hero-1.jpg" alt="" />
            </div>
            <div class="shop-hero-box">
                <div class="box-overlay"></div>
                <div class="overlay-layer">
                    <div class="overlay-content">
                        {/* <div class="inner-content">
                            <h3 class="episode-title">
                                Crazy deals on the upcoming summer sales party
                            </h3>
                            <div class="episode-meta">
                                <a href="#" class="meta-item is-hoverable">Flash Sale</a>
                                <span class="separator">|</span>
                                <span class="meta-item">2 days left</span>
                                <span class="separator">|</span>
                                <a class="meta-item is-hoverable">6 products</a>
                            </div>
                        </div> */}
                    </div>
                </div>
                <img src="https://bulkit.cssninja.io/assets/img/demo/store/hero-2.jpg" data-demo-src="https://bulkit.cssninja.io/assets/img/demo/store/hero-2.jpg" alt="" />
            </div>
            <div class="shop-hero-box">
                <div class="box-overlay"></div>
                <div class="overlay-layer">
                    <div class="overlay-content">
                        {/* <div class="inner-content">
                            <h3 class="episode-title">Follow the angel look with Rika</h3>
                            <div class="episode-meta">
                                <a href="#" class="meta-item is-hoverable">Flash Sale</a>
                                <span class="separator">|</span>
                                <span class="meta-item">147 mins left</span>
                                <span class="separator">|</span>
                                <a class="meta-item is-hoverable">5 products</a>
                            </div>
                        </div> */}
                    </div>
                </div>
                <img src="https://bulkit.cssninja.io/assets/img/demo/store/hero-3.jpg" data-demo-src="https://bulkit.cssninja.io/assets/img/demo/store/hero-3.jpg" alt="" />
            </div>
        </div>

        <div class="section">
            <div class="container">
                <div class="shop-toolbar">
                    <h4>Popular Products</h4>
                    <div class="line"></div>
                    <div class="links">
                        <a class="link">
                            <span>View All</span>
                            <i data-feather="arrow-right"></i>
                        </a>
                    </div>
                </div>

                <ProductCard ></ProductCard>
            </div>
        </div>
        {/* https://bulkit.cssninja.io/assets/img/demo/store/women.jpg */}
        <div class="section has-section-image">
        <img src="https://bulkit.cssninja.io/assets/img/demo/store/women.jpg" data-demo-src="https://bulkit.cssninja.io/assets/img/demo/store/women.jpg" alt="" />
        <div class="container">
            <div class="py-4 max-w-center max-w-640 has-text-centered">
                <h1 class="title dark-text text-bold is-bigger">Join the Pack.</h1>
                <h2 class="subtitle is-5 no-margin-bottom body-color">
                    Join our vibrant community of expert fashionistas driven by passion, not
                    by money or anything else. We live for the sake of Fashion.
                </h2>
                <div class="buttons mt-20 is-centered">
                    <a href="#product" class="button button-cta btn-align is-bold primary-btn">
                        Shop Now
                    </a>
                    <a href="#" class="button button-cta btn-align is-bold light-btn">
                        Careers
                    </a>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default Home
